import React from "react";
import { injectIntl } from "react-intl";
import TypeaheadBox from "../Form/TypeaheadBox";
import intlShape from "../../shapes/intlShape";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";

type OwnProps = {
  api: apiShape;
  intl: intlShape;
  name: string;
  notifier: notifierShape;
  assetId?: number;
  tenantId?: number;
  onlyCreate?: boolean;
  values: {
    product?: $TSFixMe;
  };
  setFieldValue: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  onlyCreate: false,
};

type Props = OwnProps & typeof defaultProps;

export function CompanyTypeaheadWithTenant(props: Props) {
  const [companies, setCompanies] = React.useState();
  const [fetching, setFetching] = React.useState();
  const {
    api,
    notifier,
    intl,
    values,
    name,
    assetId,
    tenantId,
    onlyCreate,
    setFieldValue,
  } = props;

  const loadCompanies = async (searchText = "") => {
    try {
      if (!onlyCreate) {
        // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
        setFetching(true);

        const endpoint = assetId
          ? `/assets/${assetId}/company-options`
          : "/companies";

        const parameters = {
          include: "tenant",
          name: `${searchText}*`,
        };
        if (tenantId) {
          (parameters as $TSFixMe).tenant_id = tenantId;
        }

        const response = await api.getAll(endpoint, parameters);

        setCompanies(
          response.companies.map((company: $TSFixMe) => ({
            id: company.id,
            name: company.name,
            tenantId: company?.tenant?.id,
            tenantPublic: company?.tenant?.public,
            tenantName: company?.tenant?.name,
          })),
        );
      } else {
        setCompanies(undefined);
      }
    } catch (error) {
      notifier.showError(api.translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  React.useEffect(() => {
    if (companies) {
      setFieldValue(name, null);
    }
    loadCompanies();
  }, [tenantId]);

  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const selectedCompany = values[name];

  return (
    <TypeaheadBox
      {...props}
      // @ts-expect-error TS(2322) FIXME: Type '{ info: string | null; options: undefined; f... Remove this comment to see the full error message
      info={
        selectedCompany?.new
          ? intl.formatMessage({ id: "company_typeahead.new_info" })
          : null
      }
      options={companies}
      fetching={fetching}
      loadOptions={loadCompanies}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      loadOptionsOnMount={!values[name]}
    />
  );
}

CompanyTypeaheadWithTenant.defaultProps = defaultProps;

export default injectIntl(withNotifier(withApi(CompanyTypeaheadWithTenant)));
